<template>
    <v-container grid-list-md fluid>
        <template v-if="isAuthorized">
            <!-- <v-btn
                @click="scrollToLastAccoutableAccountInteraction()"
            >
                test
            </v-btn> -->
            <template v-if="fullScreen">
                <v-row no-gutters class="mb-4">
                    <v-col cols="2" class="d-flex align-center justify-start">
                        <v-btn-back @click="resetFullScreenItem()" data-cy="GeneralLedger2-back" />
                    </v-col>
                    <v-col cols="8">
                        <v-autocomplete
                            :items="filteredGeneralLedger"
                            v-model="fullScreenItem"
                            item-title="searchModel"
                            clearable
                            :return-object="true"
                            auto-select-first
                            label="Compte"
                            elevation="0"
                            outlined
                            dense
                            hide-details
                            class="pl-2"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="2" class="d-flex align-center justify-center">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-prev
                                    v-bind="props"
                                    :disabled="!previousAa"
                                    @click="goToPreviousAa()"
                                    data-cy="GeneralLedger2-detail-back"
                                ></v-btn-prev>
                            </template>
                            <span>Compte précédent</span>
                        </v-tooltip>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-next
                                    v-bind="props"
                                    :disabled="!nextAa"
                                    @click="goToNextAa()"
                                    data-cy="GeneralLedger2-detail-next"
                                ></v-btn-next>
                            </template>
                            <span>Compte suivant</span>
                        </v-tooltip>
                        <v-spacer />
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    :icon="
                                        fullScreenItem && fullScreenItem.audited
                                            ? '$oss-circle-check'
                                            : '$oss-circle-uncheck'
                                    "
                                    v-bind="props"
                                    :color="
                                        fullScreenItem && fullScreenItem.audited
                                            ? 'primary'
                                            : 'secondary'
                                    "
                                    @click.stop="
                                        updateAccountableAccountAuditedStatus(fullScreenItem)
                                    "
                                />
                            </template>
                            <span>{{
                                fullScreenItem && fullScreenItem.audited
                                    ? "Compte révisé"
                                    : "Compte non révisé"
                            }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <AccountableAccountBalanceDetail
                        :addEndColumn="nm1"
                        :companyId="companyId"
                        :accountingPeriodId="accountingPeriodId"
                        :accountingClosingId="accountingClosingId"
                        :accountableAccountInfo="fullScreenItem"
                        :inAccountingTransactions="fullScreenItem.accountingTransactions"
                        :accountableAccountFilter="accountableAccountFilter"
                        :excludedAccountableAccountFilter="excludedAccountableAccountFilter"
                        :mode="mode"
                        tableHeight="79vh"
                        :search="fullScreenItem.search"
                        :fourLastColumnsWidth="calculedFourLastColumnsWidth"
                        :key="fullScreenItem.key"
                        :startDate="startDate"
                        :endDate="endDate"
                        :notReconciliated="withoutLettering"
                        @refresh="refresh"
                        data-cy="GeneralLedger2-table"
                    />
                </v-row>
            </template>
            <template v-else>
                <v-row v-if="!hideOptions" no-gutters class="mb-4">
                    <v-col cols="2" v-if="!isAutonomousUser" class="d-flex align-center">
                        <template v-if="hideMiscellaneousOperationsBtn"> </template>
                        <template v-else>
                            <v-btn-primary
                                @click="miscellaneousOperationDialog = true"
                                block
                                data-cy="GeneralLedger2-add"
                                >Ajouter</v-btn-primary
                            >
                        </template>
                    </v-col>
                    <v-col cols="2" v-if="!isAutonomousUser" class="pl-2 d-flex align-center">
                        <v-btn-primary
                            block
                            :disabled="!accountableAccountsSelected.length"
                            @click="exportGeneralLedgerDialog = true"
                            data-cy="GeneralLedger2-export"
                            >Exporter</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="2" class="d-flex pl-2 align-center" v-if="!hideThirdPartySwitch">
                        <v-switch
                            v-if="!isAutonomousUser"
                            hide-details
                            v-model="thirdParty"
                            :label="'Auxiliaires'"
                            class="pl-2 mt-0"
                            data-cy="GeneralLedger2-thirdParty"
                        />
                        <v-btn-icon
                            @click.stop="copyToClipboard()"
                            class="ml-3"
                            icon="$oss-duplicate"
                        />
                        <GeneralLedgerAlert
                            :check="checkBalances"
                            v-if="checkBalances && !thirdParty && !loading"
                        />
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                        <v-text-field
                            outlined
                            v-model="search"
                            hide-details
                            label="Recherche..."
                            type="text"
                            block
                            class="pl-2"
                            data-cy="GeneralLeger2-search"
                            density="compact"
                            clearable
                            append-inner-icon="$search"
                        >
                            <template v-slot:append>
                                <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-width="700"
                                    offset-y
                                    elevation="1"
                                    location="start"
                                >
                                    <template
                                        v-if="
                                            !currentUser.profile.name.startsWith(
                                                'customer-autonomous',
                                            )
                                        "
                                        v-slot:activator="{ props }"
                                    >
                                        <v-btn-icon
                                            icon="$tune"
                                            elevation="0"
                                            style="margin-top: -2px"
                                            color="secondary"
                                            v-bind="props"
                                            data-cy="GeneralLeger2-filter-icon"
                                            size="small"
                                        />
                                    </template>

                                    <v-card class="pa-3 pb-0" elevation="1">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <h2>Filtres</h2>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                            class="pt-2"
                                            v-if="isIncomingOutgoingPayment && !thirdPartyType"
                                        >
                                            <v-col cols="6">
                                                <v-switch
                                                    hide-details
                                                    v-model="bncMode"
                                                    :label="'Rapprochement E|D'"
                                                    class="pl-2 mt-0"
                                                    data-cy="GeneralLedger2-bncMode"
                                                />
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                                v-if="bncMode"
                                            >
                                                <v-select-filled
                                                    :items="transactionTypes"
                                                    v-model="transactionType"
                                                    label="Transaction"
                                                    hide-details
                                                    class="pl-2"
                                                    data-cy="GeneralLedger2-transactionType"
                                                    density="compact"
                                                    item-title="text"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="pt-2">
                                            <v-col cols="3" class="d-flex align-center">
                                                <v-switch
                                                    hide-details
                                                    v-model="nm1"
                                                    :label="'Ajouter N-1'"
                                                    class="pl-2 mt-0"
                                                    data-cy="GeneralLedger2-nm1"
                                                />
                                            </v-col>
                                            <v-col cols="4" class="d-flex align-center">
                                                <v-switch
                                                    hide-details
                                                    :disabled="nm1"
                                                    v-model="debitCredit"
                                                    :label="'Affichage débit/crédit'"
                                                    class="pl-2 mt-0"
                                                    data-cy="GeneralLedger2-debitCredit"
                                                />
                                            </v-col>
                                            <v-col
                                                cols="5"
                                                :class="$vuetify.display.mobile ? 'pl-2' : ''"
                                            >
                                                <v-select-filled
                                                    :items="filters"
                                                    v-model="filter"
                                                    label="Filtre"
                                                    class="pl-2"
                                                    hide-details
                                                    data-cy="GeneralLedger2-filter"
                                                    density="compact"
                                                    item-title="text"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="pt-2">
                                            <v-col
                                                cols="6"
                                                :class="$vuetify.display.mobile ? 'pl-2' : ''"
                                                data-cy="GeneralLedger2-mode"
                                            >
                                            </v-col>
                                        </v-row>
                                        <v-divider />
                                        <v-card-actions class="d-flex justify-end w-full">
                                            <!-- <v-btn text size="small" @click.stop="clearMenu()">
                                        <v-icon  size="small" left>$fa-sync</v-icon> Réinitialiser le filtre
                                    </v-btn> -->
                                            <v-btn
                                                @click="menu = false"
                                                data-cy="GeneralLedger-valid"
                                                size="small"
                                                variant="tonal"
                                            >
                                                Valider
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="3" class="pl-2 d-flex align-center">
                        <v-select
                            v-model="startDateLocal"
                            :items="startMonthlyDates"
                            label="Date de début"
                            hide-details
                            v-if="!accountingClosingId"
                            data-cy="GeneralLeger2-startDateLocal"
                            density="compact"
                        />
                        <v-select
                            v-model="endDateLocal"
                            :items="endMonthlyDates"
                            label="Date de fin"
                            hide-details
                            v-if="!accountingClosingId"
                            class="ml-2"
                            data-cy="GeneralLeger2-endDateLocal"
                            density="compact"
                        />
                    </v-col>
                </v-row>

                <!-- <v-radio label="Balance" value="balance"></v-radio> -->
                <v-row no-gutters v-if="loading" class="d-flex justify-center">
                    <v-progress-circular
                        :size="70"
                        :width="7"
                        color="primary"
                        indeterminate
                        style="margin: 24px"
                    />
                </v-row>
                <!-- :hide-default-header="expandedAccountableAccounts.length>0" -->
                <oss-data-table
                    v-model="accountableAccountsSelected"
                    :headers="generalLedgerHeaders"
                    :items="filteredGeneralLedger"
                    :item-key="'key'"
                    :items-per-page="-1"
                    hide-default-footer
                    v-else-if="!bncMode"
                    class="table"
                    :striped="true"
                    :dense="true"
                    fixed-header
                    :fixed-footer="true"
                    :height="dataTableHeight"
                    :showSelect="true"
                >
                    <template v-slot:item="props">
                        <tr
                            class="accountableAccountLine"
                            :key="props.item.key"
                            @click="addRemoveGeneralLedgerExpanded(props.item)"
                            :id="props.item.key"
                        >
                            <td class="d-flex justify-start align-center">
                                <v-checkbox
                                    class="pa-0 ma-0 ml-2"
                                    :ripple="false"
                                    hide-details
                                    @click.stop="props.onSelect"
                                    color="primary"
                                    :data-cy="
                                        'GeneralLedger2-balance-' + props.item.key + '-checkbox'
                                    "
                                    :model-value="props.isSelected"
                                />
                            </td>
                            <td>
                                <div class="d-flex flex-row justify-space-between align-center">
                                    <v-icon
                                        @click.stop="
                                            setFullScreenItem(props.item);
                                            fullScreen = true;
                                        "
                                        :data-cy="
                                            'GeneralLedger2-balance-' + props.item.key + '-eye'
                                        "
                                        size="small"
                                    >
                                        $oss-eye
                                    </v-icon>
                                    <v-icon
                                        v-if="props.item.name.startsWith('512')"
                                        @click.stop="openBankAccountWindow(props.item)"
                                        :data-cy="
                                            'GeneralLedger2-balance-' + props.item.key + '-edit'
                                        "
                                        size="small"
                                    >
                                        $oss-edit
                                    </v-icon>
                                    <v-icon
                                        size="small"
                                        :data-cy="
                                            'GeneralLedger2-balance-' + props.item.key + '-chevron'
                                        "
                                    >
                                        {{
                                            isGeneralLedgerExpanded(props.item)
                                                ? "$fa-chevron-up"
                                                : "$fa-chevron-down"
                                        }}
                                    </v-icon>
                                </div>
                            </td>
                            <td
                                colspan="4"
                                class="text-left"
                                :style="props.item.name.length === 3 ? 'color:red;' : ''"
                            >
                                <strong>{{ getTitle(props.item) }}</strong>
                                {{ getDate(props.item) }}
                                <v-icon
                                    v-if="containsErrors(props.item)"
                                    color="error"
                                    class="pl-2"
                                    size="small"
                                    >$fa-exclamation-triangle</v-icon
                                >
                            </td>
                            <td
                                class="text-center"
                                :id="'ColumnAudited_' + props.index"
                                v-if="showAuditedAccountableAccounts"
                            >
                                <v-btn-icon
                                    :color="props.item.audited ? 'primary' : 'secondary'"
                                    @click.stop="updateAccountableAccountAuditedStatus(props.item)"
                                    :icon="
                                        props.item.audited
                                            ? '$oss-circle-check'
                                            : '$oss-circle-uncheck'
                                    "
                                    size="small"
                                >
                                </v-btn-icon>
                            </td>
                            <template v-if="isGeneralLedgerExpanded(props.item)">
                                <td class="text-right" colspan="4">
                                    <!-- <v-text-field
                                    outlined
                                    v-model="props.item.search"
                                    dense
                                    :hide-details="true"
                                    append-inner-icon="$search"
                                    class="oss-"
                                    label="Recherche..."
                                    @click.stop="onATSearchClick(props.item)"
                                ></v-text-field> -->
                                </td>
                            </template>
                            <template v-else-if="nm1">
                                <td class="text-right" :id="'Column1_' + props.index">
                                    <strong :style="getColor(props.item.balance)">{{
                                        newCommonFormatCurrency(
                                            Math.abs(props.item.balance),
                                            undefined,
                                        )
                                    }}</strong>
                                </td>
                                <td class="text-right" :id="'Column2_' + props.index">
                                    <strong :style="getColor(props.item.previousBalance)">{{
                                        newCommonFormatCurrency(
                                            Math.abs(props.item.previousBalance),
                                            undefined,
                                        )
                                    }}</strong>
                                </td>
                                <td class="text-right" :id="'Column3_' + props.index">
                                    <strong
                                        :style="
                                            getColor(
                                                props.item.balance -
                                                    (props.item.previousBalance || 0),
                                            )
                                        "
                                        >{{
                                            newCommonFormatCurrency(
                                                (props.item.balance || 0) -
                                                    (props.item.previousBalance || 0),
                                                undefined,
                                            )
                                        }}</strong
                                    >
                                </td>
                                <td class="text-right" :id="'Column4_' + props.index">
                                    <strong
                                        :style="
                                            props.item.balance && props.item.previousBalance
                                                ? getColor(
                                                      (props.item.balance -
                                                          props.item.previousBalance) /
                                                          Math.abs(props.item.previousBalance),
                                                  )
                                                : ''
                                        "
                                        >{{
                                            percentageVariation(
                                                props.item.previousBalance,
                                                props.item.balance,
                                            )
                                        }}</strong
                                    >
                                </td>
                            </template>
                            <template v-else>
                                <td
                                    v-if="debitCredit"
                                    class="text-right"
                                    :id="'Column3_' + props.index"
                                >
                                    <div>
                                        <strong>{{
                                            props.item.debit
                                                ? newCommonFormatCurrency(
                                                      props.item.debit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </div>
                                </td>
                                <td
                                    v-if="debitCredit"
                                    class="text-right"
                                    :id="'Column4_' + props.index"
                                >
                                    <div>
                                        <strong>{{
                                            props.item.credit
                                                ? newCommonFormatCurrency(
                                                      props.item.credit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </div>
                                </td>
                                <td
                                    class="text-right"
                                    :id="(debitCredit ? 'Column5_' : 'Column3_') + props.index"
                                >
                                    <div>
                                        <strong :style="getColor(props.item.balance)">{{
                                            props.item.balance
                                                ? newCommonFormatCurrency(
                                                      Math.abs(props.item.balance),
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </div>
                                    <div
                                        v-if="deltaWithCarryForward(props.item)"
                                        style="color: red"
                                    >
                                        AN :
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.carryForward,
                                                undefined,
                                            )
                                        }}
                                    </div>
                                    <div
                                        v-if="deltaWithCarryForward(props.item)"
                                        style="color: red"
                                    >
                                        Ecart :
                                        {{
                                            newCommonFormatCurrency(
                                                deltaWithCarryForward(props.item),
                                                undefined,
                                            )
                                        }}
                                    </div>
                                </td>
                            </template>
                        </tr>
                        <tr
                            v-if="isGeneralLedgerExpanded(props.item)"
                            @click="setLastAccoutableAccountInteraction(props.item.key)"
                        >
                            <td
                                :colspan="
                                    generalLedgerHeaders.length +
                                    (showAuditedAccountableAccounts ? 2 : 1)
                                "
                                style="padding: 0; background: #f4f4f4"
                                class="py-2 px-0"
                            >
                                <AccountableAccountBalanceDetail
                                    :addEndColumn="nm1"
                                    :companyId="companyId"
                                    :accountingPeriodId="accountingPeriodId"
                                    :accountingClosingId="accountingClosingId"
                                    :accountableAccountInfo="props.item"
                                    :inAccountingTransactions="props.item.accountingTransactions"
                                    :accountableAccountFilter="accountableAccountFilter"
                                    :excludedAccountableAccountFilter="
                                        excludedAccountableAccountFilter
                                    "
                                    :mode="mode"
                                    :search="props.item.search"
                                    :fourLastColumnsWidth="calculedFourLastColumnsWidth"
                                    :key="'AABD_' + props"
                                    :startDate="startDate"
                                    :endDate="endDate"
                                    :notReconciliated="withoutLettering"
                                    @refresh="refresh"
                                    @table-height="addAdditionalHeight($event, props.item)"
                                    :thirdPartyMode="thirdParty"
                                />
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <template v-if="generalLedger.length > 0">
                            <!-- <p>thirdParty : {{thirdParty}}</p>
                        <p>thirdPartyType : {{thirdPartyType}}</p> -->
                            <template v-if="search">
                                <tr v-show="!nm1">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total recherche
                                    </th>
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            totalBalanceDebit
                                                ? newCommonFormatCurrency(
                                                      totalBalanceDebit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            totalBalanceCredit
                                                ? newCommonFormatCurrency(
                                                      totalBalanceCredit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(totalBalance)">{{
                                            totalBalance
                                                ? newCommonFormatCurrency(totalBalance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                </tr>
                                <tr v-show="nm1">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total recherche
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(totalBalance)">{{
                                            totalBalance
                                                ? newCommonFormatCurrency(totalBalance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(totalPreviousBalance)">{{
                                            totalPreviousBalance
                                                ? newCommonFormatCurrency(
                                                      totalPreviousBalance,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="getColor(totalBalance - totalPreviousBalance)"
                                            >{{
                                                totalBalance - totalPreviousBalance
                                                    ? newCommonFormatCurrency(
                                                          totalBalance - totalPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th colspan="10" />
                                </tr>
                            </template>
                            <template v-else-if="accountableAccountsSelected.length">
                                <tr v-show="!nm1">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total sélection
                                    </th>
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            totalAccountableAccountsSelectedDebit
                                                ? newCommonFormatCurrency(
                                                      totalAccountableAccountsSelectedDebit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            totalAccountableAccountsSelectedCredit
                                                ? newCommonFormatCurrency(
                                                      totalAccountableAccountsSelectedCredit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="
                                                getColor(totalAccountableAccountsSelectedBalance)
                                            "
                                            >{{
                                                totalAccountableAccountsSelectedBalance
                                                    ? newCommonFormatCurrency(
                                                          totalAccountableAccountsSelectedBalance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <th class="text-center" v-if="showAuditedAccountableAccounts" />
                                </tr>
                                <tr v-show="nm1">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total sélection
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="
                                                getColor(totalAccountableAccountsSelectedBalance)
                                            "
                                            >{{
                                                totalAccountableAccountsSelectedBalance
                                                    ? newCommonFormatCurrency(
                                                          totalAccountableAccountsSelectedBalance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="
                                                getColor(
                                                    totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                )
                                            "
                                            >{{
                                                totalAccountableAccountsSelectedDebitMCreditPreviousBalance
                                                    ? newCommonFormatCurrency(
                                                          totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="
                                                getColor(
                                                    totalAccountableAccountsSelectedBalance -
                                                        totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                )
                                            "
                                            >{{
                                                totalAccountableAccountsSelectedBalance -
                                                totalAccountableAccountsSelectedDebitMCreditPreviousBalance
                                                    ? newCommonFormatCurrency(
                                                          totalAccountableAccountsSelectedBalance -
                                                              totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <td class="text-right">
                                        <strong
                                            :style="
                                                totalAccountableAccountsSelectedBalance &&
                                                totalAccountableAccountsSelectedDebitMCreditPreviousBalance
                                                    ? getColor(
                                                          (totalAccountableAccountsSelectedBalance -
                                                              totalAccountableAccountsSelectedDebitMCreditPreviousBalance) /
                                                              totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                      )
                                                    : ''
                                            "
                                            >{{
                                                percentageVariation(
                                                    totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                    totalAccountableAccountsSelectedBalance,
                                                )
                                            }}</strong
                                        >
                                    </td>
                                </tr>
                            </template>
                            <template v-else-if="thirdParty">
                                <template
                                    v-for="account of thirdPartyAccounts.slice(
                                        0,
                                        maxThirdPartyAccsSummaryVisible,
                                    )"
                                >
                                    <tr v-show="!nm1 && !hideBodyAppend">
                                        <th
                                            class="text-right"
                                            :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                        >
                                            {{
                                                debitCredit
                                                    ? `Totaux ${account}`
                                                    : `Total ${account}`
                                            }}
                                        </th>
                                        <!-- <th class="text-right"><strong>{{newCommonFormatCurrency(total401Debit, undefined)}}</strong></th>
                                    <th class="text-right"><strong>{{newCommonFormatCurrency(total401Credit, undefined)}}</strong></th> -->
                                        <th v-if="debitCredit" class="text-right">
                                            <strong>{{
                                                newCommonFormatCurrency(
                                                    getTotalDebitThirdParty(account),
                                                    undefined,
                                                )
                                            }}</strong>
                                        </th>
                                        <th v-if="debitCredit" class="text-right">
                                            <strong>{{
                                                newCommonFormatCurrency(
                                                    getTotalCreditThirdParty(account),
                                                    undefined,
                                                )
                                            }}</strong>
                                        </th>
                                        <th class="text-right">
                                            <strong :style="getColor(total401Balance)">{{
                                                newCommonFormatCurrency(
                                                    getTotalBalanceThirdParty(account),
                                                    undefined,
                                                )
                                            }}</strong>
                                        </th>
                                    </tr>
                                    <tr v-show="nm1 && !hideBodyAppend">
                                        <th
                                            class="text-right"
                                            :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                        >
                                            Total {{ account }}
                                        </th>
                                        <th class="text-right">
                                            <strong>{{
                                                newCommonFormatCurrency(
                                                    getTotalBalanceThirdParty(account),
                                                    undefined,
                                                )
                                            }}</strong>
                                        </th>
                                        <th class="text-right">
                                            <strong>{{
                                                newCommonFormatCurrency(
                                                    getTotalPreviousBalanceThirdParty(account),
                                                    undefined,
                                                )
                                            }}</strong>
                                        </th>
                                        <th class="text-right">
                                            <strong
                                                :style="
                                                    getColor(getTotalDiffBalanceThirdParty(account))
                                                "
                                                >{{
                                                    getTotalDiffBalanceThirdParty(account)
                                                        ? newCommonFormatCurrency(
                                                              getTotalDiffBalanceThirdParty(
                                                                  account,
                                                              ),
                                                              undefined,
                                                          )
                                                        : "-"
                                                }}</strong
                                            >
                                        </th>
                                        <!--Placeholder to avoid transparent cells-->
                                        <th colspan="10" />
                                    </tr>
                                </template>
                                <template
                                    v-if="
                                        thirdPartyAccounts.length >= maxThirdPartyAccsSummaryVisible
                                    "
                                >
                                    <tr v-show="!hideBodyAppend">
                                        <th class="text-right pe-auto" colspan="100">
                                            <a
                                                role="button"
                                                @click="toggleVisibleThirdPartyAccsSummary()"
                                                >{{
                                                    maxThirdPartyAccsSummaryVisible <
                                                    thirdPartyAccounts.length
                                                        ? "Afficher plus..."
                                                        : "Afficher moins..."
                                                }}</a
                                            >
                                        </th>
                                    </tr>
                                </template>
                            </template>
                            <template v-else>
                                <tr v-show="!nm1">
                                    <th :colspan="showAuditedAccountableAccounts ? 6 : 5" />
                                    <th class="text-center">
                                        <strong
                                            ><v-icon class="mr-2" size="small"
                                                >$oss-circle-check</v-icon
                                            >{{ auditedAccountableAccountsFraction }}</strong
                                        >
                                    </th>
                                    <!-- <th class="text-right"><strong>{{newCommonFormatCurrency(totalDebit, undefined)}}</strong></th>
                                <th class="text-right"><strong>{{newCommonFormatCurrency(totalCredit, undefined)}}</strong></th> -->
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            totalBalanceDebit
                                                ? newCommonFormatCurrency(
                                                      totalBalanceDebit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            totalBalanceCredit
                                                ? newCommonFormatCurrency(
                                                      totalBalanceCredit,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(totalBalance)">{{
                                            totalBalance
                                                ? newCommonFormatCurrency(totalBalance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                </tr>
                                <tr v-show="!nm1 && !hideBodyAppend">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total charges
                                    </th>
                                    <!-- <th class="text-right"><strong>{{newCommonFormatCurrency(total6Debit, undefined)}}</strong></th>
                                <th class="text-right"><strong>{{newCommonFormatCurrency(total6Credit, undefined)}}</strong></th> -->
                                    <th v-if="debitCredit" class="text-right">
                                        <strong>{{
                                            total6Balance
                                                ? newCommonFormatCurrency(total6Balance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th v-else class="text-right">
                                        <strong :style="getColor(-total6Balance)">{{
                                            total6Balance
                                                ? newCommonFormatCurrency(-total6Balance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th v-if="debitCredit" class="text-right" colspan="20" />
                                </tr>
                                <tr v-show="!nm1 && !hideBodyAppend">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total produits
                                    </th>
                                    <th v-if="debitCredit" class="text-right" />
                                    <!-- <th class="text-right"><strong>{{newCommonFormatCurrency(total7Debit, undefined)}}</strong></th>
                                <th class="text-right"><strong>{{newCommonFormatCurrency(total7Credit, undefined)}}</strong></th> -->
                                    <th class="text-right">
                                        <strong>{{
                                            total7Balance
                                                ? newCommonFormatCurrency(-total7Balance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th v-if="debitCredit" class="text-right" colspan="10" />
                                </tr>
                                <tr v-show="!nm1 && !hideBodyAppend">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        {{ profitOrLossTitle }}
                                    </th>
                                    <!-- <th class="text-right"></th> -->
                                    <!-- <th class="text-right"></th> -->
                                    <th
                                        v-if="profitOrLoss < 0"
                                        :style="debitCredit ? '' : getColor(-profitOrLoss)"
                                        class="text-right"
                                    >
                                        <strong>{{
                                            profitOrLoss < 0
                                                ? newCommonFormatCurrency(-profitOrLoss, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th
                                        v-else-if="profitOrLoss > 0"
                                        :style="debitCredit ? '' : getColor(-profitOrLoss)"
                                        class="text-right"
                                        colspan="2"
                                    >
                                        <strong>{{
                                            profitOrLoss > 0
                                                ? newCommonFormatCurrency(-profitOrLoss, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <!-- profitOrLoss === 0 -->
                                    <th v-else colspan="2" />
                                    <!--Placeholder to avoid transparent cells-->
                                    <th colspan="20" />
                                </tr>
                                <tr v-show="nm1">
                                    <th :colspan="showAuditedAccountableAccounts ? 6 : 5" />
                                    <th class="text-center">
                                        <strong
                                            ><v-icon class="mr-2" size="small"
                                                >$oss-circle-check</v-icon
                                            >{{ auditedAccountableAccountsFraction }}</strong
                                        >
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(totalBalance)">{{
                                            totalBalance
                                                ? newCommonFormatCurrency(totalBalance, undefined)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(totalPreviousBalance)">{{
                                            totalPreviousBalance
                                                ? newCommonFormatCurrency(
                                                      totalPreviousBalance,
                                                      undefined,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <!-- <th class="text-right"><strong>{{newCommonFormatCurrency(totalPreviousBalance, undefined)}}</strong></th> -->
                                    <th class="text-right">
                                        <strong
                                            :style="getColor(totalBalance - totalPreviousBalance)"
                                            >{{
                                                totalBalance - totalPreviousBalance
                                                    ? newCommonFormatCurrency(
                                                          totalBalance - totalPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th colspan="10" />
                                </tr>
                                <tr v-show="nm1 && !hideBodyAppend">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total charges
                                    </th>
                                    <th class="text-right">
                                        <strong>{{
                                            newCommonFormatCurrency(total6Balance, undefined)
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong>{{
                                            newCommonFormatCurrency(
                                                total6PreviousBalance,
                                                undefined,
                                            )
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="getColor(total6PreviousBalance - total6Balance)"
                                            >{{
                                                total6PreviousBalance - total6Balance
                                                    ? newCommonFormatCurrency(
                                                          total6PreviousBalance - total6Balance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th colspan="10" />
                                </tr>
                                <tr v-show="nm1 && !hideBodyAppend">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        Total produits
                                    </th>
                                    <th class="text-right">
                                        <strong>{{
                                            newCommonFormatCurrency(total7Balance, undefined)
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong>{{
                                            newCommonFormatCurrency(
                                                total7PreviousBalance,
                                                undefined,
                                            )
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="getColor(total7PreviousBalance - total7Balance)"
                                            >{{
                                                total7PreviousBalance - total7Balance
                                                    ? newCommonFormatCurrency(
                                                          total7PreviousBalance - total7Balance,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th colspan="10" />
                                </tr>
                                <tr v-show="nm1 && !hideBodyAppend">
                                    <th
                                        class="text-right"
                                        :colspan="showAuditedAccountableAccounts ? 7 : 6"
                                    >
                                        {{ "Bénéfice / Perte" }}
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(-profitOrLoss)">{{
                                            profitOrLoss
                                                ? newCommonFormatCurrency(-profitOrLoss)
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong :style="getColor(profitOrLossPreviousBalance)">{{
                                            profitOrLossPreviousBalance
                                                ? newCommonFormatCurrency(
                                                      profitOrLossPreviousBalance,
                                                  )
                                                : "-"
                                        }}</strong>
                                    </th>
                                    <th class="text-right">
                                        <strong
                                            :style="
                                                getColor(profitOrLossPreviousBalance - profitOrLoss)
                                            "
                                            >{{
                                                profitOrLossPreviousBalance - profitOrLoss
                                                    ? newCommonFormatCurrency(
                                                          profitOrLossPreviousBalance -
                                                              profitOrLoss,
                                                          undefined,
                                                      )
                                                    : "-"
                                            }}</strong
                                        >
                                    </th>
                                    <!--Placeholder to avoid transparent cells-->
                                    <th colspan="10" />
                                </tr>
                            </template>
                        </template>
                    </template>
                </oss-data-table>
                <template v-else>
                    <p>Association mouvements bancaires et factures</p>
                    <AccountableAccountBalanceDetail
                        :companyId="companyId"
                        :accountingPeriodId="accountingPeriodId"
                        :accountingClosingId="accountingClosingId"
                        :accountableAccountInfo="bncAccountableAccountInfo"
                        :transactionType="bncMode ? transactionType : 'ALL'"
                        :inAccountingTransactions="[]"
                        :mode="mode"
                        :startDate="startDate"
                        :endDate="endDate"
                    >
                    </AccountableAccountBalanceDetail>
                </template>
                <!-- <AccountingItemEdition
                v-model="miscellaneousOperationDialog"
                :companyId="companyId"
                @upsert="refresh()"
                v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->

                <AccountingItemEditionDialog
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    @upsert="refresh()"
                />

                <template v-if="exportGeneralLedgerDialog">
                    <GeneralLedgerExportDialog
                        v-model:exportGeneralLedgerDialog="exportGeneralLedgerDialog"
                        :companyId="companyId"
                        :accountingPeriodId="accountingPeriodId"
                        :inStartDate="startDate"
                        :inEndDate="endDate"
                        :thirdParty="thirdParty"
                        :fromExportAccounting="false"
                        :accountableAccountsSelected="accountableAccountsSelected"
                        @exportFileFinished="exportGeneralLedgerDialog = false"
                    />
                </template>
            </template>

            <!-- <template v-if="checkBalances"> {{ formatJson(checkBalances) }} </template> -->

            <CreateBankAccount
                v-model:active="bankAccountDialog"
                :companyId="companyId"
                :bankId="selectedBankId"
                :bankAccounts="bankAccounts"
                @closeDialog="closeDialog()"
                @upserted="onBankAccountUpserted"
            />
            <!-- :companyBudgetInsightId="budgetInsightId" -->
        </template>
    </v-container>
</template>

<script lang="ts">
import colors from "vuetify/lib/util/colors";
import { Apollo } from "@/decorators";
import moment from "moment-timezone";
import { User } from "../store/store";
import gql from "graphql-tag";
// import { State2Way } from "@/decorators";

import { percentageVariation, mathFix } from "../services/mathServices";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

import AccountableAccountBalanceDetail from "./AccountableAccountBalanceDetail.vue";
import AccountingItemEditionDialog from "./accounting/accountingItem/AccountingItemEditionDialog.vue";
import OssDataTable from "./ossComponents/ossDataTable2.vue";
import GeneralLedgerExportDialog from "./GeneralLedgerExportDialog.vue";
import CreateBankAccount from "./configuration/CreateBankAccount.vue";
import GeneralLedgerAlert from "./GeneralLedgerAlert.vue";

import GENERAL_LEDGER_QUERY_2 from "../graphql/GeneralLedger.gql";
import CHECK_BALANCES from "../graphql/CheckBalances.gql";
import BANK_ACCOUNTS from "../graphql/bank/BankAccountsWithBTCount.gql";

// import EXPORT_GENERAL_LEDGER from "../graphql/accountingItem/ExportGeneralLedger.gql";
import UPDATE_ACCOUNTABLEACCOUNT_AUDITED_STATUS from "../graphql/accountableAccount/UpdateAccountableAccountAuditedStatus.gql";
import getEnv from "../env";
import {
    getAccountingPeriodStartMonths,
    getAccountingPeriodEndMonths,
} from "../services/accountingPeriods";
import { isAccountingZero } from "../services/mathServices";
import { NotificationBase } from "./NotificationBase";
import { State2Way } from "@/decorators";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";
import { checkAccessRights } from "../services/accessRightServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Watch } from "vue-facing-decorator";

const env = getEnv();
// import Monthly6And7Balances from "../graphql/budget/Monthly6And7Balances.gql";

@Component({
    components: {
        AccountableAccountBalanceDetail,
        AccountingItemEditionDialog,
        OssDataTable,
        GeneralLedgerExportDialog,
        CreateBankAccount,
        GeneralLedgerAlert,
    },
    emits: ["thirdPartyChanged", "nm1Changed", "query-done"],
})
export class GeneralLedger extends NotificationBase {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) accountingPeriodId: any;
    @Prop({ default: null }) accountingClosingId: any;
    @Prop({ default: "" }) thirdPartyType: string; // ex "401"
    @Prop({ default: undefined }) accountableAccountFilter: any; // ex ["20", "21", "22", "23", "28", "145"]
    @Prop({ default: undefined }) excludedAccountableAccountFilter: any; // ex ["20", "21", "22", "23", "28", "145"]
    @Prop({ default: null }) endDateFromParent: string;
    // @Prop({ default: null }) searchFromParent: string;  //used only in admin mode
    @Prop({ default: false }) hideOptions: boolean; // hide search, auxiliaires, ... line
    @Prop({ default: null }) withoutLetteringIfHidedOptions: boolean; // to use if hideOptions is true and you want to query only notReconciliated
    @Prop({ default: false }) hideMiscellaneousOperationsBtn: boolean;
    @Prop({ default: false }) hideThirdPartySwitch: boolean;
    @Prop({ default: false }) hideBodyAppend: boolean;
    @Prop({ default: null }) availableCompanyNames: any;
    @Prop({ default: 0 }) refreshCount: number;
    @Prop({ default: false }) store: boolean; // catch options from store - to avoid in audits
    @Prop({ default: "" }) tableHeight: string;
    @Prop({ default: undefined }) inFilter: string[]; // ** never used: replaced by accountableAccountFilter

    @Prop({ default: null }) inNm1: boolean; // add N-1 column - needs @nm1Changed="showNm1 = !showNm1"
    @Prop({ default: null }) inThirdParty: boolean; // switch Auxiliaires, used only if value true or false (other then default null) -  needs @thirdPartyChanged="showThirdParty = !showThirdParty"
    @Prop({ default: false }) enableAuditedAccountableAccounts: boolean;
    @Prop({ default: null }) bundleGeneralLedger: any[];

    headers = [];

    date: string = "";

    bankAccountDialog = false;
    selectedBankId = "";

    miscellaneousOperationDialog = false;
    exportGeneralLedgerDialog = false;
    exportWindowStep = 0;

    accountableAccountsSelected = [];

    menu = false;

    debitCreditLocal: boolean = null;

    //
    // search
    //

    searchLocal = "";

    endDateLocal: string = "";
    startDateLocal: string = "";

    heights = {};

    additionalHeights = [];

    fullScreen: boolean = false;

    fullScreenItem_: any = null;

    defaultFullScreenItem: any = {
        accountingTransactionCount: null,
        accountingTransactions: null,
        amountSigned: null,
        audited: null,
        balance: null,
        bankAccountName: null,
        bankAccountType: null,
        credit: null,
        debit: null,
        description: null,
        displayName: null,
        key: null,
        name: null,
        previousBalance: null,
        search: null,
        searchModel: null,
        splitedType: null,
    };

    get fullScreenItem() {
        if (this.fullScreenItem_) {
            return this.fullScreenItem_;
        }
        return this.defaultFullScreenItem;
    }

    set fullScreenItem(data) {
        this.fullScreenItem_ = data;
    }

    // fullScreenItem: any = null

    @State2Way(
        "updateLastAccoutableAccountInteraction",
        "generalLedger.lastAccoutableAccountInteraction",
    )
    lastAccoutableAccountInteraction: string;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "generalLedger");
        return authorized;
    }

    get enableBank() {
        return (
            this.currentUser.profile?.configuration?.bankTransaction?.read &&
            (!this.currentUser.companyUser || !this.currentUser.companyUser?.accessRights?.length)
        );
    }

    get accountingPeriod() {
        return this.$store.getters.getAccountingPeriodFromId(this.accountingPeriodId);
    }

    get accountingClosing() {
        if (this.accountingPeriod && this.accountingClosingId) {
            return this.accountingPeriod.accountingClosings.find(
                (ac) => ac.id === this.accountingClosingId,
            );
        }
        return null;
    }

    get startDate() {
        // if(this.endDateFromParent) {
        //     return this.endDateFromParent
        // }
        if (this.accountingClosing) {
            return this.accountingPeriod.start;
        }
        return this.startDateLocal;
    }

    get endDate() {
        if (this.endDateFromParent) {
            return this.endDateFromParent;
        }
        if (this.accountingClosing) {
            return this.accountingClosing.endDate;
        }
        return this.endDateLocal;
    }

    get startMonthlyDates() {
        const months = getAccountingPeriodStartMonths(this.accountingPeriod);
        months.splice(0, 0, { title: "Date de début", value: "" });
        return months;
    }

    get endMonthlyDates() {
        const months = getAccountingPeriodEndMonths(this.accountingPeriod);
        months.splice(0, 0, { title: "Date de fin", value: "" });
        return months;
    }

    get startDateIfValid() {
        return this.startDate &&
            moment(this.startDate).isValid() &&
            moment(this.startDate).isBefore(this.endDate)
            ? getDBFormattedStartDate(this.startDate)
            : undefined;
    }

    get endDateIfValid() {
        return this.endDate && moment(this.endDate).isValid()
            ? getDBFormattedEndDate(this.endDate)
            : undefined;
    }

    get search() {
        // if(this.searchFromParent) {
        //     return this.searchFromParent
        // }
        if (this.store) {
            return this.$store.state.generalLedger.search;
        }
        return this.searchLocal;
    }

    set search(data) {
        if (this.store) {
            this.$store.commit("updateSearchGeneralLedger", data);
        }
        this.searchLocal = data;
    }

    get dataTableHeight() {
        // let result = "min( calc(" + (32 * (this.filteredGeneralLedger.length + 5)) + "px), 80vh)"
        // if (this.additionalHeights.length) {
        //     let sum = this.additionalHeights.join(' + ')
        //     result = "min( calc(" + (32 * (this.filteredGeneralLedger.length + 2)) + "px + " + sum + "), 80vh)"
        // }
        if (this.tableHeight) {
            return this.tableHeight;
        }
        return "80vh";
    }

    //
    // mode
    //
    modeLocal = "";

    get mode() {
        if (this.store) {
            return this.$store.state.generalLedger.mode;
        }
        return this.modeLocal;
    }

    set mode(data) {
        if (this.store) {
            this.$store.commit("updateModeGeneralLedger", data);
        } else {
            this.modeLocal = data;
        }
    }

    //
    // expandedAccountableAccountsLocal
    //

    expandedAccountableAccountsLocal = [];

    get expandedAccountableAccounts() {
        if (this.store) {
            return this.$store.state.generalLedger.expandedAccountableAccounts;
        }
        return this.expandedAccountableAccountsLocal;
    }

    set expandedAccountableAccounts(data) {
        if (this.store) {
            this.$store.commit("updateExpandedAccountableAccountsGeneralLedger", data);
        } else {
            this.expandedAccountableAccountsLocal = data;
        }
    }

    //
    // filter
    //

    filters = [
        { value: "ALL", text: "Tous les comptes" },
        { value: "onlyBalanced", text: "Comptes soldés" },
        { value: "onlyNotBalanced", text: "Comptes non soldés" },
        { value: "onlyNotBalancedAndWithoutLettering", text: "Ecritures non lettrées" },
        { value: "onlyAudited", text: "Comptes révisés" },
        { value: "onlyNotAudited", text: "Comptes non révisés" },
    ];

    filterLocal = "";

    get filter() {
        if (this.store) {
            return this.$store.state.generalLedger.filter;
        }
        return this.filterLocal;
    }

    set filter(data) {
        if (this.store) {
            this.$store.commit("updateFilterGeneralLedger", data);
        } else {
            this.filterLocal = data;
        }
    }

    get onlyBalanced() {
        return this.filter === "onlyBalanced";
    }

    get onlyNotBalanced() {
        return this.filter === "onlyNotBalanced";
    }

    get withoutLettering() {
        if (this.hideOptions && this.withoutLetteringIfHidedOptions !== null) {
            return this.withoutLetteringIfHidedOptions;
        }
        return this.filter === "onlyNotBalancedAndWithoutLettering";
    }

    get onlyNotAudited() {
        return this.filter === "onlyNotAudited";
    }

    get onlyAudited() {
        return this.filter === "onlyAudited";
    }

    get auditedAccountableAccountsFraction() {
        return (
            this.filteredGeneralLedger.filter((aa) => aa.audited).length +
            "/" +
            this.filteredGeneralLedger.length
        );
    }

    //
    // transactionType
    //

    transactionTypeLocal = "";

    get transactionType() {
        if (this.store) {
            return this.$store.state.generalLedger.transactionType;
        }
        return this.transactionTypeLocal;
    }

    set transactionType(data) {
        if (this.store) {
            this.$store.commit("updateTransactionTypeGeneralLedger", data);
        } else {
            this.transactionTypeLocal = data;
        }
    }

    //
    // bncMode
    //

    bncModeLocal = "";

    get bncMode() {
        if (this.store) {
            return this.$store.state.generalLedger.bncMode;
        }
        return this.bncModeLocal;
    }

    set bncMode(data) {
        if (this.store) {
            this.$store.commit("updateBNCModeGeneralLedger", data);
        } else {
            this.bncModeLocal = data;
        }
    }

    //
    //  thirdParty()
    //
    thirdPartyLocal = false;

    get thirdParty() {
        // debugger
        if (this.inThirdParty !== null) {
            return this.inThirdParty;
        } else if (this.store) {
            return this.$store.state.generalLedger.thirdParty;
        }
        return this.thirdPartyLocal;
    }

    set thirdParty(data) {
        // debugger
        this.accountableAccountsSelected = [];
        if (this.inThirdParty !== null) {
            this.$emit("thirdPartyChanged", data);
        } else if (this.store) {
            this.$store.commit("updateThirdPartyGeneralLedger", data);
        } else {
            this.thirdPartyLocal = data;
        }
    }

    //
    //  nm1
    //
    nm1Locale = false;

    get nm1() {
        // debugger
        if (this.inNm1 !== null) {
            return this.inNm1;
        }
        if (this.store) {
            return this.$store.state.generalLedger.nm1;
        }
        return this.nm1Locale;
    }

    set nm1(data) {
        // debugger
        if (this.inNm1 !== null) {
            this.$emit("nm1Changed", data);
        } else if (this.store) {
            this.$store.commit("updateNm1GeneralLedger", data);
        } else {
            this.nm1Locale = data;
        }

        console.log("thirdPartyAccounts", this.thirdPartyAccounts);
    }

    get debitCredit() {
        if (this.nm1) {
            return false;
        }
        if (this.store) {
            return this.$store.state.generalLedger.debitCredit;
        }
        if (this.debitCreditLocal !== null) {
            return this.debitCreditLocal;
        }
        return true;
    }

    set debitCredit(data) {
        if (this.store) {
            this.$store.commit("updateDebitCreditGeneralLedger", data);
        } else {
            this.debitCreditLocal = data;
        }
    }

    transactionTypes = [
        { value: "ALL", text: "Encaissement et Décaissement" },
        { value: "income", text: "Encaissement" },
        { value: "outcome", text: "Décaissement" },
    ];

    get bncAccountableAccountInfo() {
        return {
            bnc: true,
        };
    }

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    beforeMount() {
        if (!this.filters.find((f) => this.filter === f.value)) {
            this.filter = "ALL";
        }
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    percentageVariation(startNumber, endNumber) {
        if (
            startNumber === null ||
            endNumber === undefined ||
            endNumber === null ||
            endNumber === undefined
        )
            return "-";
        return percentageVariation(startNumber, endNumber);
    }

    get filteredGeneralLedger() {
        if (this.bundleGeneralLedger) {
            return this.bundleGeneralLedger;
        }
        if (this.search) {
            const search = this.search.toLowerCase();
            const generalLedger = [];
            for (const item of this.generalLedger) {
                if (this.onlyNotBalanced) {
                    if (isAccountingZero(item.balance)) {
                        continue;
                    }
                }
                if (this.onlyBalanced) {
                    if (!isAccountingZero(item.balance)) {
                        continue;
                    }
                }
                if (item.name && item.name.toLowerCase().startsWith(search)) {
                    generalLedger.push(item);
                } else if (
                    item.description &&
                    item.description.toLowerCase().indexOf(search) !== -1
                ) {
                    generalLedger.push(item);
                } else if (item.balance && (item.balance + "").startsWith(search)) {
                    generalLedger.push(item);
                } else if (this.debitCredit) {
                    if (item.credit && (item.credit + "").startsWith(search)) {
                        generalLedger.push(item);
                    } else if (item.debit && (item.debit + "").startsWith(search)) {
                        generalLedger.push(item);
                    }
                }
            }
            return generalLedger;
        } else if (this.onlyNotBalanced) {
            const generalLedger = [];
            for (const item of this.generalLedger) {
                if (!isAccountingZero(item.balance)) {
                    generalLedger.push(item);
                }
            }
            return generalLedger;
        } else if (this.onlyBalanced) {
            const generalLedger = [];
            for (const item of this.generalLedger) {
                if (isAccountingZero(item.balance)) {
                    generalLedger.push(item);
                }
            }
            return generalLedger;
        } else if (this.onlyAudited) {
            const generalLedger = [];
            for (const item of this.generalLedger) {
                if (item.audited) {
                    generalLedger.push(item);
                }
            }
            return generalLedger;
        } else if (this.onlyNotAudited) {
            const generalLedger = [];
            for (const item of this.generalLedger) {
                if (!item.audited) {
                    generalLedger.push(item);
                }
            }
            return generalLedger;
            // **  never used: replaced by accountableAccountFilter
        } else if (this.inFilter) {
            let generalLedger = [];
            if (this.inFilter.length) {
                for (const aa of this.inFilter) {
                    generalLedger.push(...this.generalLedger.filter((x) => x.name.startsWith(aa)));
                }
                generalLedger = generalLedger.sort((a, b) => {
                    return a.name - b.name;
                });
            }
            return generalLedger;
        }
        return this.generalLedger;
    }

    calculedFourLastColumnsWidth = [];

    getFourLastColumnsWidth() {
        // debugger
        if (
            document.getElementById("Column1_1") &&
            document.getElementById("Column2_1") &&
            document.getElementById("Column3_1")
            // document.getElementById("Column4_1")
        ) {
            this.calculedFourLastColumnsWidth = [
                document.getElementById("Column1_1").clientWidth,
                document.getElementById("Column2_1").clientWidth,
                document.getElementById("Column3_1").clientWidth,
                // document.getElementById("Column4_1").clientWidth
            ];
        }
        return this.calculedFourLastColumnsWidth;
    }

    //
    // generalLedger
    //

    // get generalLedgerHeaders() {
    //     const headers = [
    //         { text: '', value: '', sortable: false },
    //         { text: "Compte comptable", value: "", align: "left", sortable: false },
    //         { text: "", value: "", sortable: false },
    //         { text: "", value: "", sortable: false },
    //         { text: "", value: "", sortable: false },
    //         { text: "Débit", value: "", align: "right", sortable: false },
    //         { text: "Crédit", value: "", align: "right", sortable: false },
    //         { text: "Solde", value: "", align: "right", sortable: false }
    //     ]
    //     if (this.nm1) {
    //         headers.push({ text: "Solde N-1", value: "previousBalance", align: "right", sortable: false })
    //     }
    //     return headers
    // }

    get generalLedgerHeaders() {
        if (this.isAutonomousUser) {
            const headers = [
                { text: "", value: "checkbox", sortable: false },
                // { text: '', value: 'unexpand', sortable: false },
                { text: "Postes", value: "", align: "left", sortable: false },
                { text: "", value: "", sortable: false },
                { text: "", value: "", sortable: false },
                { text: "", value: "", sortable: false },
            ];
            if (this.showAuditedAccountableAccounts) {
                headers.push({ text: "Révisé", value: "", align: "center", sortable: false });
            }
            headers.push({ text: "Solde", value: "", align: "right", sortable: false });
            return headers;
        }
        if (this.nm1) {
            const headers = [
                { text: "", value: "checkbox", sortable: false },
                // { text: '', value: 'unexpand', sortable: false },
                { text: "Compte comptable", value: "", align: "left", sortable: false },
                { text: "", value: "", sortable: false },
                { text: "", value: "", sortable: false },
                { text: "", value: "", sortable: false },
            ];
            if (this.showAuditedAccountableAccounts) {
                headers.push({ text: "Révisé", value: "", align: "center", sortable: false });
            }
            headers.push({ text: "Solde N", value: "", align: "right", sortable: false });
            headers.push({ text: "Solde N-1", value: "", align: "right", sortable: false });
            headers.push({ text: "Ecart", value: "", align: "right", sortable: false });
            headers.push({ text: "Variation %", value: "", align: "right", sortable: false });

            return headers;
        }
        const headers = [
            { text: "", value: "checkbox", sortable: false },
            // { text: '', value: 'unexpand', sortable: false },
            { text: "Compte comptable", value: "", align: "left", sortable: false },
            { text: "", value: "", sortable: false },
            { text: "", value: "", sortable: false },
            { text: "", value: "", sortable: false },
        ];
        if (this.showAuditedAccountableAccounts) {
            headers.push({ text: "Révisé", value: "", align: "center", sortable: false });
        }
        if (this.debitCredit) {
            headers.push(
                { text: "Débit", value: "", align: "right", sortable: false },
                { text: "Crédit", value: "", align: "right", sortable: false },
            );
        }
        // else {
        headers.push({ text: "Solde", value: "", align: "right", sortable: false });
        // }

        return headers;
    }

    @Watch("refreshCount")
    onRefreshCount(value, prevValue) {
        if (value && prevValue !== value) {
            this.refresh();
        }
    }

    // @Watch("generalLedger", { deep: true })
    // @Watch("companyId")
    // @Watch("accountingPeriodId")
    // @Watch("thirdParty")
    // @Watch("filter")
    onGeneralLedger(value) {
        if (this.expandedAccountableAccounts.length) {
            const expandedAccountableAccounts = this.expandedAccountableAccounts;
            this.expandedAccountableAccounts = [];
            for (const item of expandedAccountableAccounts) {
                const newItem = this.generalLedger.find((glItem) => glItem.key === item.key);
                if (newItem) {
                    this.expandedAccountableAccounts.push(newItem);
                }
            }
        }
    }

    isGeneralLedgerExpanded(item) {
        const index = this.expandedAccountableAccounts.indexOf(item);
        return index !== -1;
    }

    emptyFunction() {}

    addRemoveGeneralLedgerExpanded(item) {
        this.setLastAccoutableAccountInteraction(item.key);
        const index = this.expandedAccountableAccounts.findIndex((aa) => aa.key === item.key);
        if (index === -1) {
            this.expandedAccountableAccounts.push(item);
        } else {
            this.expandedAccountableAccounts.splice(index, 1);
        }
        this.$nextTick(() => {
            this.getFourLastColumnsWidth();
        });
    }

    // unexpandAllAas() {
    //     this.expandedAccountableAccounts = []
    // }

    get generalLedgerDisplay() {
        if (this.expandedAccountableAccounts.length === this.generalLedger.length)
            return "generalLedger";
        if (this.expandedAccountableAccounts.length === 0) return "balance";
        return "";
    }

    set generalLedgerDisplay(value) {
        if (value === "generalLedger") {
            this.expandedAccountableAccounts.splice(0, this.expandedAccountableAccounts.length);
            this.expandedAccountableAccounts.push(...this.generalLedger);
        } else {
            this.expandedAccountableAccounts.splice(0, this.expandedAccountableAccounts.length);
        }
    }

    get totalPreviousBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            total += item.previousBalance;
        }
        return total;
    }

    get total6PreviousBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name && item.name.startsWith("6")) total += item.previousBalance;
        }
        return total;
    }

    get total7PreviousBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name && item.name.startsWith("7")) total += item.previousBalance;
        }
        return total;
    }

    get profitOrLossPreviousBalance() {
        return -(this.total7PreviousBalance + this.total6PreviousBalance);
    }

    // get totalDebit() {
    //     let total = 0.0;
    //     for (const item of this.filteredGeneralLedger) {
    //         total += item.totalDebit
    //     }
    //     return total
    // }

    // get totalCredit() {
    //     let total = 0.0;
    //     for (const item of this.filteredGeneralLedger) {
    //         total += item.totalCredit
    //     }
    //     return total
    // }

    get totalBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            total += item.balance;
        }
        return total;
        // const diff = this.totalDebit - this.totalCredit;
        // if (Math.abs(diff) < 0.005) {
        //     return 0.0;
        // }
        // return this.totalDebit - this.totalCredit;
    }

    get totalBalanceDebit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            total += item.debit;
        }
        return total;
        // const diff = this.totalDebit - this.totalCredit;
        // if (Math.abs(diff) < 0.005) {
        //     return 0.0;
        // }
        // return this.totalDebit - this.totalCredit;
    }

    get totalBalanceCredit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            total += item.credit;
        }
        return total;
        // const diff = this.totalDebit - this.totalCredit;
        // if (Math.abs(diff) < 0.005) {
        //     return 0.0;
        // }
        // return this.totalDebit - this.totalCredit;
    }

    // get total6Debit() {
    //     let total = 0.0;
    //     for (const item of this.generalLedger) {
    //         if (item.name && item.name.startsWith("6")) total += item.totalDebit
    //     }
    //     return total
    // }

    // get total6Credit() {
    //     let total = 0.0;
    //     for (const item of this.generalLedger) {
    //         if (item.name && item.name.startsWith("6")) total += item.totalCredit
    //     }
    //     return total
    // }

    get total6Balance() {
        let total = 0.0;
        const generalLedger = this.bundleGeneralLedger
            ? this.bundleGeneralLedger
            : this.generalLedger;
        for (const item of generalLedger) {
            if (item.name && item.name.startsWith("6")) total += item.balance;
        }
        return total;
        // return this.total6Debit - this.total6Credit
    }

    // get total7Debit() {
    //     let total = 0.0;
    //     for (const item of this.generalLedger) {
    //         if (item.name && item.name.startsWith("7")) total += item.totalDebit
    //     }
    //     return total
    // }

    // get total7Credit() {
    //     let total = 0.0;
    //     for (const item of this.generalLedger) {
    //         if (item.name && item.name.startsWith("7")) total += item.totalCredit
    //     }
    //     return total
    // }

    get total7Balance() {
        let total = 0.0;
        const generalLedger = this.bundleGeneralLedger
            ? this.bundleGeneralLedger
            : this.generalLedger;
        for (const item of generalLedger) {
            if (item.name && item.name.startsWith("7")) total += item.balance;
        }
        return total;
        // return this.total7Debit - this.total7Credit
    }

    get profitOrLoss() {
        return this.total6Balance + this.total7Balance;
        // return this.total6Credit + this.total7Credit - (this.total6Debit + this.total7Debit)
    }

    get profitOrLossTitle() {
        return this.profitOrLoss < 0 ? "Bénéfice" : "Perte";
    }

    get total401Debit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("401")) total += item.debit;
        }
        return total;
    }

    get total401Credit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("401")) total += item.credit;
        }
        return total;
    }

    get total401Balance() {
        let total = 0.0;
        // console.log("this.filteredGeneralLedger", this.filteredGeneralLedger)
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("401")) total += item.balance;
        }
        return total;
        // return this.total401Debit - this.total401Credit
    }

    get total401PreviousBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name && item.name.startsWith("401")) total += item.previousBalance;
        }
        return total;
    }

    get total411Debit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("411")) total += item.debit;
        }
        return total;
    }

    get total411Credit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("411")) total += item.credit;
        }
        return total;
    }

    get total411Balance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("411")) total += item.balance;
        }
        return total;
        // return this.total411Debit - this.total411Credit
    }

    get total411PreviousBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name && item.name.startsWith("411")) total += item.previousBalance;
        }
        return total;
    }

    get total421Debit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("421")) total += item.debit;
        }
        return total;
    }

    get total421Credit() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("421")) total += item.credit;
        }
        return total;
    }

    get total421Balance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith("421")) total += item.balance;
        }
        return total;
        // return this.total421Debit - this.total421Credit
    }

    get total421PreviousBalance() {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name && item.name.startsWith("421")) total += item.previousBalance;
        }
        return total;
    }

    get totalAccountableAccountsSelectedBalance() {
        let total = 0;
        for (const key of this.accountableAccountsSelected) {
            const aa = this.filteredGeneralLedger.find((aa) => aa.key === key);
            total += aa?.balance || 0;
        }
        return total;
    }

    get totalAccountableAccountsSelectedDebit() {
        let total = 0;
        for (const key of this.accountableAccountsSelected) {
            const aa = this.filteredGeneralLedger.find((aa) => aa.key === key);
            total += aa?.debit || 0;
        }
        return total;
    }

    get totalAccountableAccountsSelectedCredit() {
        let total = 0;
        for (const key of this.accountableAccountsSelected) {
            const aa = this.filteredGeneralLedger.find((aa) => aa.key === key);
            total += aa?.credit || 0;
        }
        return total;
    }

    get totalAccountableAccountsSelectedDebitMCreditPreviousBalance() {
        let total = 0.0;
        for (const item of this.accountableAccountsSelected) {
            const aa = this.filteredGeneralLedger.find((aa) => aa.name.startsWith(item));
            total += aa?.previousBalance;
        }
        return total;
    }

    @Watch("startDate")
    onStartDateChanged(value) {
        const startDate = moment(this.startDate);
        for (const endDate of this.endMonthlyDates) {
            if (moment(endDate.value).isBefore(startDate)) {
                endDate.disabled = true;
            } else {
                endDate.disabled = false;
            }
        }
    }

    @Watch("endDate")
    onEndDateChanged(value) {
        const endDate = moment(this.endDate);
        for (const startDate of this.startMonthlyDates) {
            if (moment(startDate.value).isAfter(endDate)) {
                startDate.disabled = true;
            } else {
                startDate.disabled = false;
            }
        }
    }

    containsErrors(item) {
        if (item.error) {
            return true;
        }
        if (item.name?.startsWith("XXXXXX")) {
            return true;
        }
        for (const accountingTransaction of item.accountingTransactions) {
            if (accountingTransaction.object && accountingTransaction.object.error) {
                return true;
            }
        }

        return false;
    }

    accountingTransactionStyle(accountingTransaction) {
        let style = "";
        if (accountingTransaction && accountingTransaction.object) {
            style = "cursor:pointer;";
            if (accountingTransaction.object.error) {
                style += `background-color: ${colors.red.accent1};`;
            }
        }
        return style;
    }

    openAccountingTransaction(accountingTransaction) {
        if (accountingTransaction.object) {
            if (accountingTransaction.object.type === "document") {
                this.$router.push({
                    name: "document",
                    params: {
                        companyId: this.companyId,
                        id: accountingTransaction.object.id,
                    },
                });
            } else if (accountingTransaction.object.type === "bankTransaction") {
                this.$router.push({
                    name: "reconciliation/bankTransaction",
                    params: {
                        companyId: this.companyId,
                        bankTransactionId: accountingTransaction.object.id,
                    },
                });
            } else if (accountingTransaction.object.type === "reconciliation") {
                this.$router.push({
                    name: "reconciliation",
                    params: {
                        companyId: this.companyId,
                        reconciliationId: accountingTransaction.object.id,
                    },
                });
            } else if (accountingTransaction.object.type === "expenseReport") {
                this.$router.push({
                    name: "expenseReport",
                    params: {
                        companyId: this.companyId,
                        id: accountingTransaction.object.id,
                        //   documentId: document.id
                    },
                });
            } else if (accountingTransaction.object.type === "zTillReceipt") {
                this.$router.push({
                    name: "zTillReceipt",
                    params: {
                        companyId: this.companyId,
                        id: accountingTransaction.object.id,
                        // documentId: document.id
                    },
                });
            }
        }
    }

    deltaWithCarryForward(item) {
        if (item.carryForward === undefined) {
            return 0.0;
        }
        const delta = item.balance - item.carryForward;
        if (Math.abs(delta) > 1e-2) {
            return delta;
        }
        return 0.0;
    }

    addAdditionalHeight(data, item) {
        this.heights[item.name] = data;
        this.computeAdditionalHeight();
    }

    @Watch("expandedAccountableAccounts", { deep: true })
    computeAdditionalHeight() {
        if (this.expandedAccountableAccounts.length) {
            const localAdditionalHeights = [];
            const expandedAcc = this.expandedAccountableAccounts.map((acc) => acc.name);
            expandedAcc.forEach((acc) => {
                localAdditionalHeights.push(this.heights[acc]);
            });
            this.additionalHeights = localAdditionalHeights;
        } else {
            this.additionalHeights = [];
        }
    }

    getTitle(item) {
        const aaName = item.name || "";
        let title = "";
        if (this.isAutonomousUser && item.description) {
            title = item.description;
        } else {
            title = item.description ? aaName + " - " + item.description : aaName;
        }
        return title;
    }

    getDate(item) {
        if (item.name.startsWith("512") && item.bankAccountName) {
            const bankAccount = this.bankAccounts.find((ba) => ba.name === item.bankAccountName);
            if (bankAccount?.startAuthorizedDate) {
                return `(clôture des flux : ${moment(bankAccount.startAuthorizedDate).format(
                    "DD/MM/YYYY",
                )})`;
            }
        }
        return "";
    }

    // selectAll(){
    //     if(this.accountableAccountsSelected.length === this.generalLedger.length) {
    //         this.accountableAccountsSelected = []
    //     } else {
    //         this.accountableAccountsSelected = this.filteredGeneralLedger.map(x => x.key)
    //     }
    // }

    //
    //
    //
    @Apollo(
        {
            query: BANK_ACCOUNTS,
            variables() {
                return {
                    companyId: this.selectedCompany.id,
                    type: "BANK",
                };
            },
            skip() {
                return !this.isAuthorized || !this.enableBank || !this.selectedCompany?.id;
            },
        },
        (data) => (data && data.bankAccounts ? data.bankAccounts : []),
    )
    bankAccounts = [];
    //
    // general ledger
    //

    get showAuditedAccountableAccounts() {
        if (this.enableAuditedAccountableAccounts && this.accountingPeriod) {
            if (
                (!this.startDate ||
                    moment(this.accountingPeriod.start).format("YYYY-MM-DD") ===
                        moment(this.startDate).format("YYYY-MM-DD")) &&
                (!this.endDate ||
                    moment(this.accountingPeriod.end).format("YYYY-MM-DD") ===
                        moment(this.endDate).format("YYYY-MM-DD"))
            )
                return true;
        }
        return false;
    }

    @Apollo({
        query: GENERAL_LEDGER_QUERY_2,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                accountingClosingId: this.accountingClosingId,
                thirdParty: this.thirdParty,
                thirdPartyType: this.thirdPartyType,
                mode: this.mode,
                accountableAccountFilter: this.accountableAccountFilter || undefined,
                excludedAccountableAccountFilter:
                    this.excludedAccountableAccountFilter || undefined,
                computeNm1: this.nm1,
                startDate: this.startDateIfValid,
                endDate: this.endDateIfValid,
                availableCompanyNames: this.availableCompanyNames,
                updateAuditedAccountableAccounts: this.showAuditedAccountableAccounts,
                notReconciliated: this.withoutLettering,
                // excludeLog:"VAT"
            };
        },
        // fetchPolicy: "network-only",
        skip() {
            return (
                !this.isAuthorized ||
                !this.companyId ||
                !this.accountingPeriodId ||
                (this.endDate && !moment(this.endDate).isValid())
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                const generalLedger = data.generalLedger?.generalLedger;
                if (generalLedger) {
                    for (const row of generalLedger) {
                        if (row.accountingTransactionCount !== undefined) {
                            // hack : result is called twice ou three time with the same data
                            return;
                        }
                        row.accountingTransactionCount = 0;
                        row.search = "";
                    }

                    // if (this.withoutLettering) {
                    //     generalLedger = generalLedger.filter((aa) => !aa.letteringDate);
                    // }

                    this.generalLedger = generalLedger.map((aa) => ({
                        ...aa,
                        searchModel: aa.name + " - " + aa.description,
                    }));
                    this.balanceCheck = data.generalLedger.check;
                    this.onGeneralLedger();
                } else {
                    this.generalLedger = [];
                    this.balanceCheck = null;
                }
            } else {
                this.generalLedger = [];
                this.balanceCheck = null;
            }
            setTimeout(() => {
                this.scrollToLastAccoutableAccountInteraction();
            }, 750);

            this.$emit("query-done", {
                generalLedger: this.generalLedger,
                // total401Debit: this.total401Debit,
                // total401Credit: this.total401Credit,
                // total411Debit: this.total411Debit,
                // total411Credit: this.total411Credit,
                // total421Debit: this.total421Debit,
                // total421Credit: this.total421Credit,
                // totalDebit: this.totalDebit,
                // totalCredit: this.totalCredit,
                total401Balance: this.total401Balance,
                total411Balance: this.total411Balance,
                total421Balance: this.total421Balance,
                totalBalance: this.totalBalance,
                accountableAccountFilter: this.accountableAccountFilter || undefined,
                excludedAccountableAccountFilter:
                    this.excludedAccountableAccountFilter || undefined,
                accountingPeriodId: this.accountingPeriodId || undefined,
            });
        },
    })
    generalLedger: any[] = [];

    balanceCheck = null;

    @Apollo({
        query: CHECK_BALANCES,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        // fetchPolicy: "network-only",
        skip() {
            return (
                !this.isAuthorized ||
                !this.companyId ||
                !this.balanceCheck ||
                this.balanceCheck?.status ||
                this.thirdParty ||
                this.thirdPartyType
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                if (data.checkBalances) {
                    this.checkBalances = data.checkBalances.result;
                    if (this.checkBalances.corrections?.totalCount) {
                        this.refresh();
                    }
                } else {
                    this.checkBalances = null;
                }
            } else {
                this.checkBalances = null;
            }
        },
    })
    checkBalances = null;

    @Watch("generalLedger")
    onBalancesChanged() {
        this.checkBalances = null;
    }

    get loading() {
        if (this.$apollo.queries && this.$apollo.queries.generalLedger) {
            const loading = this.$apollo.queries.generalLedger.loading;
            if (loading && this.generalLedger.length) {
                this.generalLedger = [];
            }
            return loading;
        }
        return false;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.generalLedger) {
            this.$apollo.queries.generalLedger.refetch();
        }
    }

    onATSearchClick(item) {}

    getColor(amount) {
        return amount <= -1e-2 ? "color:red;" : "";
    }

    nextStepExportDialog() {
        this.exportWindowStep++;
    }

    setLastAccoutableAccountInteraction(key: string) {
        this.lastAccoutableAccountInteraction = key;
    }

    scrollToLastAccoutableAccountInteraction() {
        if (!this.lastAccoutableAccountInteraction) {
            return;
        }
        const element = document.getElementById(this.lastAccoutableAccountInteraction);
        if (element) {
            element.scrollIntoView();
        }
    }

    async updateAccountableAccountAuditedStatus(item) {
        item.audited = !item.audited;
        await this.$apollo.mutate({
            mutation: UPDATE_ACCOUNTABLEACCOUNT_AUDITED_STATUS,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                accountableAccountKey: item.key,
                audited: item.audited,
                balance: item.balance,
            },
        });
    }

    async setAllAccountableAccountsAsAudited() {
        if (!this.filteredGeneralLedger.length) {
            return;
        }

        const aasToUpdate = this.filteredGeneralLedger.filter(({ audited }) => !audited);

        for (const aa of aasToUpdate) {
            await this.updateAccountableAccountAuditedStatus(aa);
        }
    }

    async setAllAccountableAccountsAsUnaudited() {
        if (!this.filteredGeneralLedger.length) {
            return;
        }

        const aasToUpdate = this.filteredGeneralLedger.filter(({ audited }) => audited);

        for (const aa of aasToUpdate) {
            await this.updateAccountableAccountAuditedStatus(aa);
        }
    }

    resetFullScreenItem() {
        this.fullScreen = false;
        this.fullScreenItem = null;
    }

    setFullScreenItem(item) {
        this.fullScreenItem = item;
    }

    openBankAccountWindow(item) {
        const selectedBank = this.bankAccounts.find((ba) => ba.name === item.bankAccountName);
        if (selectedBank) {
            this.selectedBankId = selectedBank.id;
            this.bankAccountDialog = true;
        }
    }

    onBankAccountUpserted(bankAccount) {
        const selectedBankIndex = this.bankAccounts.findIndex((ba) => ba.id === bankAccount.id);
        if (selectedBankIndex !== -1) {
            this.bankAccounts.splice(0, 1, bankAccount);
        }
    }

    goToPreviousAa() {
        this.setFullScreenItem(this.previousAa);
    }

    goToNextAa() {
        this.setFullScreenItem(this.nextAa);
    }

    get nextAa() {
        let nextAa = null;
        if (this.fullScreenItem) {
            const currentIndex = this.filteredGeneralLedger.findIndex(
                (aa) => aa.key === this.fullScreenItem.key,
            );
            nextAa = this.filteredGeneralLedger[currentIndex + 1];
        }
        return nextAa;
    }

    get previousAa() {
        let previousAa = null;
        if (this.fullScreenItem) {
            const currentIndex = this.filteredGeneralLedger.findIndex(
                (aa) => aa.key === this.fullScreenItem.key,
            );
            previousAa = this.filteredGeneralLedger[currentIndex - 1];
        }
        return previousAa;
    }

    closeDialog() {
        this.selectedBankId = "";
        // this.refresh();
    }

    getAmountAsString(amount: number) {
        let valueS = mathFix(amount).toString();
        if (valueS) {
            valueS = valueS.replace(".", ",");
        }
        return valueS;
    }

    async copyToClipboard() {
        let text = "";
        text += "Comptes";
        text += "\t";
        text += "Description";
        text += "\t";
        if (this.nm1) {
            text += "Solde N";
            text += "\t";
            text += "Solde N-1";
            text += "\t";
            text += "Ecart";
            text += "\t";
            text += "Variation";
            text += "\n";
        } else {
            text += "Débit";
            text += "\t";
            text += "Crédit";
            text += "\t";
            text += "Solde";
            text += "\n";
        }

        for (const balance of this.filteredGeneralLedger) {
            text += balance.name;
            text += "\t";
            text += balance.description;
            text += "\t";
            if (this.nm1) {
                const percentageS = this.percentageVariation(
                    balance.previousBalance,
                    balance.balance,
                );
                text += this.getAmountAsString(balance.balance);
                text += "\t";
                text += this.getAmountAsString(balance.previousBalance);
                text += "\t";
                text += this.getAmountAsString(
                    (balance.balance || 0) - (balance.previousBalance || 0),
                );
                text += "\t";
                text += percentageS?.replace(".", ",") || "";
                text += "\n";
            } else {
                text += this.getAmountAsString(balance.debit);
                text += "\t";
                text += this.getAmountAsString(balance.credit);
                text += "\t";
                text += this.getAmountAsString(balance.balance);
                text += "\n";
            }
        }
        await navigator.clipboard.writeText(text);
    }

    maxThirdPartyAccsSummaryVisible = 3; // Max number of accounts lines at the bottom of the table when thirdParty is set

    toggleVisibleThirdPartyAccsSummary() {
        this.maxThirdPartyAccsSummaryVisible =
            this.maxThirdPartyAccsSummaryVisible >= this.thirdPartyAccounts.length
                ? 3
                : this.thirdPartyAccounts.length;
    }

    get thirdPartyAccounts() {
        const threeLetterAccounts = [];
        if (this.thirdParty) {
            for (const item of this.filteredGeneralLedger) {
                const shortAccountNumber = item.name.substring(0, 3);
                if (!threeLetterAccounts.find((x) => x === shortAccountNumber)) {
                    threeLetterAccounts.push(shortAccountNumber);
                }
            }
        }
        threeLetterAccounts.sort();
        return threeLetterAccounts;
    }

    getTotalDebitThirdParty(threeLettersAcc) {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith(threeLettersAcc)) total += item.debit;
        }
        return total;
    }

    getTotalCreditThirdParty(threeLettersAcc) {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith(threeLettersAcc)) total += item.credit;
        }
        return total;
    }

    getTotalBalanceThirdParty(threeLettersAcc) {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name.startsWith(threeLettersAcc)) total += item.balance;
        }
        return total;
        // return this.total401Debit - this.total401Credit
    }

    getTotalPreviousBalanceThirdParty(threeLettersAcc) {
        let total = 0.0;
        for (const item of this.filteredGeneralLedger) {
            if (item.name && item.name.startsWith(threeLettersAcc)) total += item.previousBalance;
        }
        return total;
    }

    getTotalDiffBalanceThirdParty(threeLettersAcc) {
        return (
            this.getTotalBalanceThirdParty(threeLettersAcc) -
            this.getTotalPreviousBalanceThirdParty(threeLettersAcc)
        );
    }

    // formatJson(json) {
    //     JSON.stringify(json, null, 2);
    // }
}

export default toNative(GeneralLedger);
</script>

<style scoped>
.accountableAccountLine {
    background: #fff;
    transition: background 0.3s;
}

.accountableAccountLine:hover {
    background: #ffe8b5 !important;
}
</style>
